import { useEffect, useRef, useState } from "react";
import { api } from "../api";
import type { Dir, DuelView } from "../components/duel/duel";
import { DuelRecap } from "../components/duel/DuelRecap";
import { DuelStage } from "../components/duel/DuelStage";
import { ResultSheet } from "../components/ResultSheet";
import { Centered, Header, Shell } from "../components/Shell";
import { Toast } from "../components/Toast";
import { useGame } from "../useGame";

const COPY = { bad_pick: "Тільки більше або менше" };
/** The last verdict (count-up, ✓/✗) lands before the sheet. */
const OPTS = { sheetDelayMs: 1900 };

export function Bilshe({ date }: { date?: string | undefined }) {
  const g = useGame<DuelView>("bilshe", COPY, date, OPTS);
  const restored = useRef<{ finished: boolean } | null>(null);
  const sheetShown = useRef(false);
  const [recap, setRecap] = useState(false);

  const state = g.screen.kind === "game" ? g.screen.state : null;
  const finished = state !== null && state.status !== "playing";

  // A fresh finish keeps the last duel under the sheet; closing the sheet shows the chain.
  useEffect(() => {
    if (g.sheetOpen) sheetShown.current = true;
    else if (sheetShown.current && finished) setRecap(true);
  }, [g.sheetOpen, finished]);

  if (g.screen.kind === "loading") return <Shell><Centered>…</Centered></Shell>;
  if (g.screen.kind === "error") {
    return (
      <Shell>
        <Centered>
          <div>{g.screen.message}</div>
          {g.screen.retry && (
            <button type="button" onClick={() => void g.load()} className="rounded-xl bg-tgbutton px-5 py-2.5 text-sm font-semibold text-tgbuttontext">
              ще раз
            </button>
          )}
        </Centered>
      </Shell>
    );
  }
  const s = g.screen.state;
  const v = s.view;
  const m = v.metric;
  const won = s.status === "won";
  restored.current ??= { finished };
  const showRecap = finished && (restored.current.finished || recap);

  const pick = (dir: Dir) => void g.run(() => api.guess<DuelView>("bilshe", dir, date));

  return (
    <Shell header={<Header left={date ? `📼 ${date}` : `#${s.number}`} title="БІЛЬШЕ-МЕНШЕ" right={date ? "" : `🔥 ${s.me.streak}`} />}>
      <div className="flex min-h-0 flex-1 flex-col overflow-y-auto px-3 pb-[calc(var(--tg-safe-area-inset-bottom,0px)+10px)] pt-1">
        {showRecap ? <DuelRecap view={v} /> : <DuelStage view={v} busy={g.busy} onPick={pick} />}
      </div>

      <Toast message={g.toast} />
      {g.sheetOpen && finished && (
        <ResultSheet
          state={s}
          archive={Boolean(date)}
          title={won ? (m.key === "pop" ? "Демограф!" : m.key === "area" ? "Картограф!" : "Економіст!") : "Не сьогодні"}
          subtitle={won ? `${v.correct}/${v.total} · стрік ${s.me.streak} 🔥` : `${v.correct}/${v.total} · треба ${v.winAt}+ · стрік згорів`}
          scoreLabel="avg промахів"
          formatScore={(n) => `${n}`}
          onDismiss={() => g.setSheetOpen(false)}
        />
      )}
    </Shell>
  );
}
